module.exports = __webpack_public_path__ + "img/图片.b2e8be27.png";